import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "component-title fw-bold small border-bottom pb-2 mb-3" };
const _hoisted_2 = { class: "d-flex align-items-center" };
const _hoisted_3 = {
    key: 0,
    style: { "max-width": "190px" },
    class: "me-4"
};
const _hoisted_4 = {
    for: "bottleDarkenOverview",
    class: "form-label fw-bold"
};
const _hoisted_5 = { class: "form-check form-switch" };
const _hoisted_6 = {
    class: "form-check-label fw-bold",
    for: "movingPreviewSwitch"
};
const _hoisted_7 = { class: "mb-4" };
const _hoisted_8 = {
    key: 0,
    class: "h-100 d-flex align-items-center justify-content-center position-relative py-5"
};
const _hoisted_9 = { class: "position-absolute top-0 start-0 w-100 text-center" };
const _hoisted_10 = { class: "overview-box-title d-inline-block fw-bold border border-primary rounded px-3 py-2" };
const _hoisted_11 = {
    key: 1,
    class: "h-100 d-flex align-items-center justify-content-center position-relative py-5"
};
const _hoisted_12 = { class: "position-absolute top-0 start-0 w-100 text-center" };
const _hoisted_13 = { class: "overview-box-title d-inline-block fw-bold border border-primary rounded px-3 py-2" };
const _hoisted_14 = {
    style: { "height": "700px" },
    class: "d-flex align-items-center justify-content-center mt-4"
};
const _hoisted_15 = {
    key: 2,
    class: "h-100 d-flex align-items-center justify-content-center position-relative py-5"
};
const _hoisted_16 = { class: "position-absolute top-0 start-0 w-100 text-center" };
const _hoisted_17 = { class: "overview-box-title d-inline-block fw-bold border border-primary rounded px-3 py-2" };
const _hoisted_18 = {
    style: { "height": "700px" },
    class: "d-flex align-items-center justify-content-center mt-4"
};
const _hoisted_19 = {
    key: 3,
    class: "h-100 d-flex align-items-center justify-content-center position-relative py-5"
};
const _hoisted_20 = { class: "position-absolute top-0 start-0 w-100 text-center" };
const _hoisted_21 = { class: "overview-box-title d-inline-block fw-bold border border-primary rounded px-3 py-2" };
const _hoisted_22 = ["src"];
const _hoisted_23 = { class: "fw-bold mb-4" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { class: "row" };
const _hoisted_26 = {
    key: 0,
    class: "col-8"
};
const _hoisted_27 = { class: "ms-2" };
const _hoisted_28 = { class: "col-12 col-lg-4 d-flex align-items-center" };
const _hoisted_29 = {
    key: 0,
    class: "w-100"
};
const _hoisted_30 = { key: 0 };
const _hoisted_31 = { class: "fw-bold text-danger" };
const _hoisted_32 = {
    key: 0,
    class: "me-2"
};
const _hoisted_33 = {
    key: 1,
    class: "me-2"
};
const _hoisted_34 = ["disabled"];
const _hoisted_35 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    fill: "currentColor",
    class: "bi bi-cart-plus",
    viewBox: "0 0 16 16"
};
const _hoisted_36 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    fill: "currentColor",
    class: "bi bi-check2-circle",
    viewBox: "0 0 16 16"
};
const _hoisted_37 = { class: "ms-3" };
const _hoisted_38 = {
    key: 1,
    class: "w-100"
};
const _hoisted_39 = { class: "ms-2" };
import { onMounted, ref, watch } from 'vue';
import LidConfigurationPreview from '../Shared/LidConfigurationPreview.vue';
import PreviewContainer from '../Shared/PreviewContainer.vue';
import OrderRequest from './OrderRequest.vue';
import { Carousel } from 'primevue';
import ConfigurationPriceComposition from '../Shared/ConfigurationPriceComposition.vue';
import axios from 'axios';
import { responseMessages } from '@/Composables/responseMessages';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
import { loadTenantConfigs } from '../Composables/standardFunctions';
//TODO: Funktionen aus Konfiguration und Vorschau zusammen auslagern, ggf. einzelne Komponenten pro Vorschauobjekt, um modularer zu arbeiten
export default /*@__PURE__*/ _defineComponent({
    __name: 'Overview',
    props: {
        configurationId: String,
        tenantId: String,
        lid: Object,
        bottle: Object,
        package: Object,
        productsAmount: {
            type: Number,
            default: 100
        },
        hasOrder: {
            type: Boolean,
            default: false
        },
        hasBlockedConfigurationSteps: {
            type: Boolean,
            default: false
        }
    },
    setup(__props) {
        const { t } = useI18n();
        let { showSuccessSwal, showErrorSwal } = responseMessages();
        const props = __props;
        const standardProductType = ref(null);
        const key = ref('');
        const responsiveOptions = ref([
            {
                breakpoint: '1900px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '1400px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '750px',
                numVisible: 1,
                numScroll: 1
            }
        ]);
        const previews = ref([]);
        const addedToCart = ref(false);
        const totalConfigurationPrice = ref(0);
        const hasZeroColoringPrices = ref(false);
        const orderAllowed = ref(false);
        const bottleOverlay = ref(0); //Flaschen Overlay
        const movingPreview = ref(false); //Moving Preview Flag
        onMounted(async () => {
            standardProductType.value = await loadTenantConfigs('standard_product_type');
            if (props.lid && !props.lid.printNotPossible) {
                previews.value.push('lid');
            }
            if (props.bottle) {
                previews.value.push('front');
                previews.value.push('back');
            }
            if (props.package) {
                previews.value.push('package');
            }
            loadOrderRequest();
            getPriceInfo();
        });
        watch(() => props.productsAmount, (newValue) => {
            getPriceInfo();
        });
        function showPriceOverview() {
            key.value = Math.random().toString(36).substring(7);
        }
        function addToCart() {
            axios.post(route('cart.configurations.store', props.configurationId), {
                amount: props.productsAmount
            })
                .then(function (response) {
                addedToCart.value = true;
                showSuccessSwal(t('Konfiguration wurde in den Warenkorb gelegt'));
            })
                .catch(function (error) {
                console.error(error);
                showErrorSwal(error.response.data);
            });
        }
        function loadOrderRequest() {
            axios.post(route('configurator.orderRequests.show', props.configurationId))
                .then(function (response) {
                if (response.data.orderRequest != null) {
                    addedToCart.value = response.data.orderRequest.isInCurrentCart;
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function copyConfigurationAndRestart() {
            Swal.fire({
                title: t('Konfiguration wird geladen ...'),
                icon: "info",
                timerProgressBar: true,
                showConfirmButton: false,
                background: '#fff',
                backdrop: '#fff',
                timer: 3500
            });
            axios.post(route('configurator.configurations.copy', props.configurationId))
                .then(function (response) {
                if (response.data.configurationUrl) {
                    if (window.top) {
                        window.top.location.href = response.data.configurationUrl; //to ensure the redirect works in an iframe
                    }
                    else {
                        window.location.href = response.data.configurationUrl;
                    }
                }
                else {
                    showErrorSwal(t('Fehler beim Kopieren der Konfiguration'));
                }
            })
                .catch(function (error) {
                console.error(error);
                showErrorSwal(error.response.data);
            });
        }
        function getPriceInfo() {
            axios.post(route('configurator.priceCalculation.getPriceInfo', props.configurationId), {
                amount: props.productsAmount
            })
                .then(function (response) {
                totalConfigurationPrice.value = response.data.totalPrice;
                hasZeroColoringPrices.value = response.data.hasZeroColoringPrices;
                orderAllowed.value = response.data.orderAllowed; //check if configuration has zero price components and check if order is allowed with zero prices
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(t)('Ihre Zusammenstellung')), 1),
                _createElementVNode("div", _hoisted_2, [
                    (standardProductType.value != 'glass')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('Darstellung verdunkeln')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "range",
                                class: "form-range",
                                id: "bottleDarkenOverview",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((bottleOverlay).value = $event)),
                                min: "0",
                                max: "0.5",
                                step: "0.05"
                            }, null, 512), [
                                [_vModelText, bottleOverlay.value]
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                role: "switch",
                                id: "movingPreviewSwitch",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((movingPreview).value = $event))
                            }, null, 512), [
                                [_vModelCheckbox, movingPreview.value]
                            ]),
                            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)('Bewegte Vorschau')), 1)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(Carousel), {
                        value: previews.value,
                        numVisible: 4,
                        numScroll: 1,
                        responsiveOptions: responsiveOptions.value,
                        showIndicators: false,
                        showNavigators: true,
                        class: "w-100"
                    }, {
                        item: _withCtx((slotProps) => [
                            (slotProps.data == 'lid')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("h5", _hoisted_10, _toDisplayString(_unref(t)('Verschluss')), 1)
                                    ]),
                                    _createVNode(LidConfigurationPreview, {
                                        configurationId: __props.configurationId,
                                        lid: __props.lid,
                                        previewWidth: 350
                                    }, null, 8, ["configurationId", "lid"])
                                ]))
                                : _createCommentVNode("", true),
                            (slotProps.data == 'front')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(t)('Vorderseite')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        (_openBlock(), _createBlock(PreviewContainer, {
                                            configurationId: __props.configurationId,
                                            tenantId: __props.tenantId,
                                            bottle: props.bottle,
                                            previewHeight: 650,
                                            sideView: 'front',
                                            rotate: movingPreview.value,
                                            bottleOverlay: bottleOverlay.value,
                                            key: bottleOverlay.value + '' + movingPreview.value
                                        }, null, 8, ["configurationId", "tenantId", "bottle", "rotate", "bottleOverlay"]))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (slotProps.data == 'back')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("h5", _hoisted_17, _toDisplayString(_unref(t)('Rückseite')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        (_openBlock(), _createBlock(PreviewContainer, {
                                            configurationId: __props.configurationId,
                                            tenantId: __props.tenantId,
                                            bottle: props.bottle,
                                            previewHeight: 650,
                                            sideView: 'back',
                                            rotate: movingPreview.value,
                                            bottleOverlay: bottleOverlay.value,
                                            key: bottleOverlay.value + '' + movingPreview.value
                                        }, null, 8, ["configurationId", "tenantId", "bottle", "rotate", "bottleOverlay"]))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (slotProps.data == 'package' && props.package)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("h5", _hoisted_21, _toDisplayString(_unref(t)('Verpackung')), 1)
                                    ]),
                                    _createElementVNode("img", {
                                        src: props.package.image,
                                        class: "img-fluid"
                                    }, null, 8, _hoisted_22)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["value", "responsiveOptions"])
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("h5", _hoisted_23, [
                        _createTextVNode(_toDisplayString(_unref(t)('Ihre Zusammenstellung')) + " - ", 1),
                        (props.bottle)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(props.bottle.name), 1))
                            : _createCommentVNode("", true)
                    ]),
                    (key.value != '')
                        ? (_openBlock(), _createBlock(ConfigurationPriceComposition, {
                            configurationId: props.configurationId,
                            amount: props.productsAmount,
                            key: key.value
                        }, null, 8, ["configurationId", "amount"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                        (!__props.hasOrder)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("button", {
                                    class: "btn btn-primary d-inline-flex align-items-center mb-4",
                                    type: "button",
                                    "aria-expanded": "false",
                                    "aria-controls": "overviewDetails",
                                    onClick: showPriceOverview
                                }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "currentColor",
                                        class: "bi bi-arrow-right",
                                        viewBox: "0 0 16 16"
                                    }, [
                                        _createElementVNode("path", {
                                            "fill-rule": "evenodd",
                                            d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                        })
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(t)('Details')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_28, [
                            (!props.hasOrder)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    (!addedToCart.value && (props.bottle == null))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)('Bitte min. folgende Auswahl treffen')) + ":", 1),
                                            _createElementVNode("p", {
                                                class: _normalizeClass([{ 'text-success': props.bottle, 'text-danger': props.bottle == null }, "d-flex align-items-center mb-1"])
                                            }, [
                                                (props.bottle)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, [...(_cache[5] || (_cache[5] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-check2-circle",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                                _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                            ], -1)
                                                        ]))]))
                                                    : _createCommentVNode("", true),
                                                (props.bottle == null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, [...(_cache[6] || (_cache[6] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-x",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                            ], -1)
                                                        ]))]))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(_toDisplayString(standardProductType.value == 'glass' ? _unref(t)('Glas') : _unref(t)('Flasche')), 1)
                                            ], 2)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", null, [
                                        (totalConfigurationPrice.value > 0 && !hasZeroColoringPrices.value && orderAllowed.value && !props.hasBlockedConfigurationSteps)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "w-100 btn btn-lg btn-primary fw-bold d-inline-flex align-items-center justify-content-center mb-3",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (addToCart())),
                                                disabled: addedToCart.value || props.bottle == null
                                            }, [
                                                (!addedToCart.value)
                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_35, [...(_cache[7] || (_cache[7] = [
                                                            _createElementVNode("path", { d: "M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9z" }, null, -1),
                                                            _createElementVNode("path", { d: "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }, null, -1)
                                                        ]))]))
                                                    : _createCommentVNode("", true),
                                                (addedToCart.value)
                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_36, [...(_cache[8] || (_cache[8] = [
                                                            _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }, null, -1),
                                                            _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" }, null, -1)
                                                        ]))]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(t)('In den Warenkorb')), 1)
                                            ], 8, _hoisted_34))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", null, [
                                        (props.bottle)
                                            ? (_openBlock(), _createBlock(OrderRequest, {
                                                key: 0,
                                                tenantId: props.tenantId,
                                                configurationId: __props.configurationId,
                                                productsAmount: props.productsAmount
                                            }, null, 8, ["tenantId", "configurationId", "productsAmount"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (props.hasOrder)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('Vielen Dank für Ihre Bestellung!')), 1),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('Sie möchten diese Konfiguration erneut bestellen und ggf. anpassen? Kein Problem!')), 1),
                                    _createElementVNode("button", {
                                        class: "btn btn-primary fw-bold d-inline-flex align-items-center justify-content-center mb-3",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (copyConfigurationAndRestart()))
                                    }, [
                                        _cache[9] || (_cache[9] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-arrow-return-right",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5"
                                            })
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)('Jetzt neu konfigurieren')), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
